import { cn } from "~/lib/ui";

export const LocationIcon = ({
  width = "16",
  height = "16",
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 13 17"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("inline", className)}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#2a2e3b"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6.5 16.54c4-4.45 6-7.79 6-10.01C12.5 3.2 9.81.5 6.5.5S.5 3.2.5 6.53c0 2.22 2 5.56 6 10.01z" />
        <circle cx="6.5" cy="6.5" r="2.5" />
      </g>
    </svg>
  );
};
